import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  const isActive = user?.platformUser?.isActive === "true";

  // Not logged in → redirect to home
  if (!user) return <Navigate to="/" replace />;

  // Logged in but inactive → show inactive message or redirect
  if (!isActive) {
    return (
      <div style={{ padding: "2rem", color: "red", fontWeight: "bold" }}>
        ⛔ Your account is inactive. Please contact support.
      </div>
    );

    // or redirect somewhere:
    // return <Navigate to="/inactive" replace />;
  }

  return children;
};

export default ProtectedRoute;
